<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Cập nhật Danh mục khóa học: {{ modelData.name }}</h2>
        <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
      </div>
    </el-row>
    <el-row>
      <div class="model-content">
        <el-col :span="12">
          <el-form label-position="top" :model="modelData" ref="createModel" label-width="135px" @submit.native.prevent>
            <!-- <el-form-item prop="avatar" label="Ảnh đại diện">
              <el-upload
                class="avatar-uploader"
                :action="upload.url"
                :headers="upload.headers"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :on-progress="handleAvatarProcess"
                :before-upload="beforeAvatarUpload">
                <img v-if="modelData.image_path" :src="modelData.image_path" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div slot="tip" class="el-upload__tip">
                  <i class="fas fa-spinner fa-spin" v-if="upload.uploadProcess"></i>
                  Ảnh tải lên có dung lượng tối đa là 1Mb, kích thước 50 x 50
                </div>
              </el-upload>
            </el-form-item> -->
            <el-form-item prop="name" label="Tên Danh mục khóa học" class="form-item"
              :rules="[
                { required: true, message: 'Vui lòng nhập tên Danh mục khóa học' }
              ]">
              <el-input v-model="modelData.name" class="input-seach" ref="myInput"></el-input>
            </el-form-item>
            <el-form-item label="Kích hoạt" prop="status">
              <el-switch
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                v-model="modelData.status">
              </el-switch>
            </el-form-item>
            <el-form-item>
                <el-button
                  :disable="!canSubmit"
                  :loading="!canSubmit"
                  type="warning"
                  size="small"
                  @click="submitForm('createModel')"
                  native-type="submit">Cập nhật</el-button>
                <el-button
                  size="small"
                  class="btn-back"
                  @click="backModel">Trở về
                </el-button>
              </el-form-item>
          </el-form>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions } from 'vuex'
import ls from 'local-storage'
export default {
  name: 'CategoryCourseUpdate',
  metaInfo () {
    return {
      title: 'Danh mục khóa học'
    }
  },
  data () {
    return {
      canSubmit: true,
      modelData: {
        name: '',
        status: false
      },
      upload: {
        uploadProcess: false,
        url: process.env.API_URI + 'category-courses/upload',
        headers: {
          Authorization: ''
        }
      }
    }
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchModel()
    this.configUpload()
  },
  methods: {
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'category-courses-index', text: 'Danh mục khóa học' },
        { name: 'category-courses-update', text: 'Cập nhật' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Cấu hình Upload
    configUpload () {
      const token = ls.get('authen', '')
      if (token) {
        this.upload.headers.Authorization = `Bearer ${token.access_token}`
      } else {
        this.upload.headers.Authorization = 'Bearer'
      }
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'category-courses-index'})
    },
    // Tải dữ liệu Model xuống
    fetchModel () {
      this.canSubmit = false
      axios.get('category-courses/' + this.$route.params.id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.modelData = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Lưu dữ liệu
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.updateModel()
        } else {
          this.$notify({
            title: 'Lỗi dữ liệu nhập',
            message: 'Vui lòng kiểm tra lại thông tin',
            type: 'warning'
          })
          return false
        }
      })
    },
    updateModel () {
      this.canSubmit = false
      axios.put('category-courses/' + this.$route.params.id, this.modelData).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật Danh mục khóa học thành công',
              type: 'success'
            })
            this.$router.push({name: 'category-courses-index'})
            // this.$router.push({name: 'category-courses-show', params: {id: this.$route.params.id}})
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },

    // Upload Ảnh
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isLt2M) {
        this.$message.error('Ảnh có dung lượng ảnh tối đa là 2M')
      }
      return isLt2M
    },
    handleAvatarSuccess (response) {
      this.upload.uploadProcess = false
      if (response.code) {
        this.modelData.image = response.data.name
        this.modelData.image_path = response.data.path
      }
    },
    handleAvatarProcess (event, file, fileList) {
      this.upload.uploadProcess = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/category-courses/Update.vue